
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buy-tickets",
      function () {
        return require("private-next-pages/buy-tickets.tsx");
      }
    ]);
  